import { AssessmentTarget } from "./assessment-target";
import { ProjectPart } from "./project-part";

export class AssessmentMeasure extends ProjectPart {
  name: string;
  active: boolean;
  sortOrder: string;
  measureData: {
    measure: string,
    description: string,
    methodology: string,
    analysisOfFindings: string
  };
  measureSourceOfEvidence: any; //todo string?
  sourceOfEvidence: any; //todo string?
  //targetsList: AssessmentTarget[[]];
  targetList: AssessmentTarget[];
  referenceILOMeasureGuid: string;
  newAddedID: number;
  isBeingEdited: boolean = false;

  fieldsDisabled: boolean = false;
  titleDisabled: boolean = false;
  descriptionDisabled: boolean = false;
  methodologyDisabled: boolean = false;

  targetsexpanded: boolean = false;

  constructor(
    prefix: string = "",
    id: number = 0,
    requestKey: string = "",
    expanded: boolean = true,
    active: boolean = true,
    sortOrder: string = "",
    measure: string = "",
    description: string = "",
    methodology: string = "",
    analysisOfFindings: string = "",
    measureSourceOfEvidence: string = "",
    sourceOfEvidence: string = "",
    targetList: AssessmentTarget[] = [],
    referenceILOMeasureGuid: string = null,
    newAddedID: number = 0,
    fieldsDisabled: boolean = false,
    titleDisabled: boolean = false,
    descriptionDisabled: boolean = false,
    methodologyDisabled: boolean = false,
    targetsExpanded: boolean = false,
  ) {
    super("measure", id, requestKey, expanded, prefix);
    this.active = active;
    this.sortOrder = sortOrder;
    this.measureData = {
      measure: measure,
      description: description,
      methodology: methodology,
      analysisOfFindings: analysisOfFindings
    };
    this.measureSourceOfEvidence = measureSourceOfEvidence;
    this.sourceOfEvidence = sourceOfEvidence;
    this.targetList = targetList;
    this.referenceILOMeasureGuid = referenceILOMeasureGuid;
    this.newAddedID = newAddedID;
    this.fieldsDisabled = fieldsDisabled;
    this.titleDisabled = titleDisabled;
    this.descriptionDisabled = descriptionDisabled;
    this.methodologyDisabled = methodologyDisabled;
    this.targetsexpanded = targetsExpanded;
  }
}
